/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
export const onReady = (callback) => {
    if (document.readyState != "loading") callback();
    else if (document.addEventListener) document.addEventListener("DOMContentLoaded", callback);
    else document.attachEvent("onreadystatechange", function () {
        if (document.readyState == "complete") callback();
    });
};

export function getNextSibling(elem, selector) {
    var sibling = elem.nextElementSibling;

    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.nextElementSibling;
    }
}

export function isNullOrUndefined(value) {
    return value === undefined || value === null || value === "";
}

export function extractHostname(url, tld) {
    var hostname;
    if (url.indexOf("//") > -1) {
        hostname = url.split("/")[2];
    } else {
        hostname = url.split("/")[0];
    }
    hostname = hostname.split(":")[0];
    hostname = hostname.split("?")[0];

    if (tld) {
        const hostnames = hostname.split(".");
        hostname = hostnames[hostnames.length - 2] + "." + hostnames[hostnames.length - 1];
    }

    return hostname;
}

export function containsAny(str, substrings) {
    const lstr = str.toLowerCase();
    for (let i = 0; i !== substrings.length; i++) {
        const substring = substrings[i].toLowerCase();
        if (lstr.indexOf(substring) !== -1) {
            return substring;
        }
    }
    return null;
}

export function updateQueryString(key, value, url) {
    if (!url) url = window.location.href;
    var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

    if (re.test(url)) {
        if (typeof value !== "undefined" && value !== null)
            return url.replace(re, "$1" + key + "=" + value + "$2$3");
        else {
            hash = url.split("#");
            url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
            if (typeof hash[1] !== "undefined" && hash[1] !== null) url += "#" + hash[1];
            return url;
        }
    } else {
        if (typeof value !== "undefined" && value !== null) {
            var separator = url.indexOf("?") !== -1 ? "&" : "?";
            hash = url.split("#");
            url = hash[0] + separator + key + "=" + value;
            if (typeof hash[1] !== "undefined" && hash[1] !== null) url += "#" + hash[1];
            return url;
        } else return url;
    }
}

export function getUrlVars() {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split("=");
        var paramid = hash[0].toLowerCase();
        vars.push(paramid);
        vars[paramid] = hash[1];
    }
    return vars;
}

export function convertHMS(value) {
    const sec = parseInt(value, 10);
    let hours = Math.floor(sec / 60 / 60);
    let minutes = Math.floor(sec / 60) - hours * 60;
    let seconds = sec % 60;
    let formatted = "";

    if (hours > 0) {
        formatted = hours.toString().padStart(2, "0") + ":";
    }

    formatted += minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");

    return formatted;
}

export function getWithExpiry(key) {
    let itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }

    let item = JSON.parse(itemStr);
    let now = new Date();

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage and return null
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
}

export function setWithExpiry(key, value, seconds) {
    let now = new Date();
    // `item` is an object which contains the original value as well as the time when it's supposed to expire
    let item = {
        value: value,
        expiry: now.getTime() + seconds * 1000
    };

    localStorage.setItem(key, JSON.stringify(item));
}

export function getCurrentLanguage(fallback) {
    return window.currentLanguage || fallback || "en";
}
window.getCurrentLanguage = getCurrentLanguage;

export function getCurrentRegion(fallback) {
    return window.currentRegion || fallback || "NA";
}

export function createCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

export function getCookie(name) {
    var v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : null;
}

export function loadScript(src, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";

    // IE
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState === "loaded" || script.readyState === "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    }
    // Others
    else {
        script.onload = callback;
    }

    script.src = src;
    document.head.appendChild(script);
}

/**
 * Get Character Count
 * @param {string
 * @param {number}
 */
export function getCharCount(str) {
    return str.length;
}

/**
 * Get Word Count
 * @param {string}
 * @param {number}
 */
export function getWordCount(str) {
    const words = removeTags(str).split(" ");
    return words.filter((word) => word.trim() !== "").length;
}

/**
 * Trim whitespace
 * @param {string}
 * @param {string}
 */
export function trimSpaces(str) {
    return str.replace(/(^\s*)|(\s*$)/gi, "");
}

/**
 * Remove HTML Tags from string
 * @param {string}
 * @param {string}
 */
export function removeTags(str) {
    if (str === null || str === "") {
        return false;
    }

    return str.replace(/<[^>]+>/g, "");
}

export function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

export function getBootstrapBreakpoint() {
    const breakpoints = {
        xs: window.matchMedia("(max-width: 767px)"),
        sm: window.matchMedia("(min-width: 768px) and (max-width: 991px)"),
        md: window.matchMedia("(min-width: 992px) and (max-width: 1199px)"),
        lg: window.matchMedia("(min-width: 1200px)")
    };

    for (const breakpoint in breakpoints) {
        if (breakpoints[breakpoint].matches) {
            return breakpoint;
        }
    }
}

export function isMobileView() {
    return window.matchMedia("(max-width: 767px)").matches;
}